<template>
  <div class="customer-jobs loader-container">
    <h2>Jobs</h2>
    <div class="actions loader-container">
      <button @click.prevent="deleteCustomerJobs">Clear Jobs</button>
      <button @click.prevent="getCustomerJobs">Refresh</button>
      <Loader :loading="processingAction" />
    </div>
    <div class="table-wrapper loader-container">
      <vue-good-table
        v-if="customerJobs"
        :columns="[
          {
            label: 'Customer',
            field: 'customerComponent.customer.customerName'
          },
          {
            label: 'Component',
            field: 'customerComponent.component.componentName'
          },
          {
            label: 'Action',
            field: 'action'
          },
          {
            label: 'Date Created',
            field: 'dateCreated',
            formatFn: formatDateTime
          },
          {
            label: 'Created By',
            field: 'createdBy'
          },
          {
            label: 'Date Run',
            field: 'dateRun',
            formatFn: formatDateTime
          },
          {
            label: 'Run By',
            field: 'runBy'
          },
          {
            label: 'Date Completed',
            field: 'dateCompleted',
            formatFn: formatDateTime
          },
          {
            label: 'Date Failed',
            field: 'dateFailed',
            formatFn: formatDateTime
          },
          {
            label: 'Error',
            field: 'error'
          }
        ]"
        :rows="customerJobs"
      ></vue-good-table>
      <Loader :loading="loadingJobs" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Loader, VueGoodTable },
  props: {
    customerId: { type: String, default: null },
    refresh: { type: Number, default: 0 }
  },
  data() {
    return {
      customerJobs: [],
      loadingJobs: false,
      processingAction: false
    };
  },
  watch: {
    refresh: function() {
      this.getCustomerJobs();
    }
  },
  created() {
    this.getCustomerJobs();
  },
  methods: {
    getCustomerJobs() {
      var self = this;
      self.loadingJobs = true;
      service
        .getCustomerJobs(self.customerId)
        .then(response => {
          self.customerJobs = response.data;
          self.loadingJobs = false;
        })
        .catch(() => {
          self.loadingJobs = false;
        });
    },
    deleteCustomerJobs() {
      var self = this;
      self.processingAction = true;
      service
        .deleteCustomerJobs(self.customerId)
        .then(() => {
          self.processingAction = false;
          self.getCustomerJobs();
        })
        .catch(() => {
          self.processingAction = false;
        });
    }
  }
};
</script>
